module.exports = __webpack_public_path__ + "static/img/station.96947f4b.svg";